
    
    import { defineComponent } from 'vue';
    import * as jQuery from 'jquery';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    export default defineComponent({
        data() {
            return {
            };
        },
        props: {
            dclang_msgnotif: String,
        },
        methods: {
          
        },
        mounted() {
            Swal.fire({
                toast: true,
                position: 'top-end',
                customClass: {
                    container: 'dctoastcontainer'
                },
                icon: 'success',
                title: this.dclang_msgnotif,
                showConfirmButton: false,
                timer: 2500
            });
        }
    });
